import Title from 'components/common/Title';
import LinkButton from 'components/common/LinkButton';
import { useIntl } from 'react-intl';
import Content from 'components/common/Content-v2';
import MembersTable from 'components/tables/members';
const Members = () => {
	const { formatMessage } = useIntl();
	return (
		<>
			<Title>
				<h1>{formatMessage({ id: 'dashboard.members' })}</h1>
				<LinkButton to="/admin/members/add">{formatMessage({ id: 'commons.add' })}</LinkButton>
			</Title>
			<Content>
				<MembersTable />
			</Content>
		</>
	);
};
export default Members;
